window.dbs = window.dbs || {}
dbs.utilities = dbs.utilities || {}

dbs.utilities.querystring = function () {
  const self = this

  self.removeParameter = function (name, url) {
    if (!url) url = window.location.href
    if (url === undefined) return

    const [path, searchParams] = url.includes('?') ? url.split('?') : [url, undefined]
    if (searchParams === undefined) return path

    let newSearchParams = searchParams
      ?.split('&')
      .filter(
        (param) =>
          !(param.toLowerCase() === name.toLowerCase() || param.toLowerCase().startsWith(`${name.toLowerCase()}=`)),
      )
      .join('&')

    return `${path}?${newSearchParams}`
  }

  self.getParameter = function (name, url) {
    if (!url) url = window.location.href
    if (url === undefined) return

    // eslint-disable-next-line no-unused-vars
    const [, searchParams] = url.includes('?') ? url.split('?') : [url, undefined]

    if (searchParams === undefined) return

    const params = new URLSearchParams(searchParams)
    const paramsToLower = new URLSearchParams([...params].map(([key, value]) => [key.toLowerCase(), value]))
    name = name.replace(/[[\]]/g, '\\$&') // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_string_as_the_replacement
    return paramsToLower.get(name.toLowerCase())
  }
}
